import React from "react";

import "./loading-spinner.scss";

function LoadingSpinnerScreen(props: any) {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className={"loading-spinner " + props.className}></div>
    </div>
  );
}

export default LoadingSpinnerScreen;
